import {
  cookieString,
  secureCookieAttribute,
  storyworthCookieDomainAttribute,
} from "./cookies"

const IMPACT_CLICK_ID_COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60
// Mirrors CLICK_ID_RE in utils/impact.py so only ids the server accepts are stored.
const IMPACT_CLICK_ID_RE = /^[A-Za-z0-9_-]{1,255}$/

export function saveImpactClickId() {
  saveImpactClickIdParam("im_ref")
  saveImpactClickIdParam("irclickid")
}

function saveImpactClickIdParam(name: string) {
  const clickId = new URLSearchParams(window.location.search).get(name)
  if (!clickId || !IMPACT_CLICK_ID_RE.test(clickId)) return

  const domainAttribute = storyworthCookieDomainAttribute()
  const secureAttribute = secureCookieAttribute()
  // Remove any legacy host-only cookie, which would otherwise shadow the
  // `.storyworth.com` cookie written below.
  if (domainAttribute) {
    document.cookie = cookieString(name, "", [
      "max-age=0",
      "path=/",
      "SameSite=Lax",
      secureAttribute,
    ])
  }

  document.cookie = cookieString(name, encodeURIComponent(clickId), [
    `max-age=${IMPACT_CLICK_ID_COOKIE_MAX_AGE_SECONDS}`,
    "path=/",
    "SameSite=Lax",
    domainAttribute,
    secureAttribute,
  ])
}
